import React from 'react';
import { Typography } from '@material-ui/core';
import SchoolOutlinedIcon from '@material-ui/icons/SchoolOutlined';
import DesktopMacOutlinedIcon from '@material-ui/icons/DesktopMacOutlined';
import AssignmentOutlinedIcon from '@material-ui/icons/AssignmentOutlined';
import ViewModuleOutlinedIcon from '@material-ui/icons/ViewModuleOutlined';
import AccessTimeOutlinedIcon from '@material-ui/icons/AccessTimeOutlined';
import EmojiEventsOutlinedIcon from '@material-ui/icons/EmojiEventsOutlined';
import PlayCircleOutlineIcon from '@material-ui/icons/PlayCircleOutline';
import CastForEducationIcon from '@material-ui/icons/CastForEducation';
import AddIcon from '@material-ui/icons/Add';
import { useTranslation } from 'react-i18next';
import Animation from '../../../../components/Animation';
import {
	TrainingOptionsContainer,
	TrainingTitle,
	OptionsGrid,
	OptionCard,
	OptionHeading,
	OptionDivider,
	ModuleList,
	ModuleCount,
	FeatureList,
	Feature,
	FeatureIcon,
	PlusDivider,
	HybridFeatureList,
	Callout
} from './styles';

const Icon = ({ children }) => <FeatureIcon>{children}</FeatureIcon>;

const TrainingOptions = () => {
	const { t, i18n } = useTranslation();

	if (i18n.language !== 'es') return null;

	const onlineModules = t('general.trainingOptions.online.modules', {
		returnObjects: true
	});

	return (
		<TrainingOptionsContainer>
			<Animation animateIn="fadeInDown">
				<TrainingTitle variant="h2">
					{t('general.trainingOptions.title')}
				</TrainingTitle>
			</Animation>

			<OptionsGrid>
				<OptionCard
					as="a"
					className="option-card-link"
					href="#program"
					aria-label={t('general.program.title')}
				>
					<OptionHeading>
						<Icon>
							<SchoolOutlinedIcon />
						</Icon>
						<Typography variant="h3">
							<span>{t('general.trainingOptions.online.titleFirst')}</span>{' '}
							<span className="title-second">
								{t('general.trainingOptions.online.titleSecond')}
							</span>
						</Typography>
					</OptionHeading>
					<OptionDivider />
					<ModuleList>
						<ModuleCount>
							<Icon>
								<ViewModuleOutlinedIcon />
							</Icon>
							<Typography variant="body1">
								{t('general.trainingOptions.online.moduleCount')}
							</Typography>
						</ModuleCount>
						<ol>
							{onlineModules.map((module, index) => (
								<li key={module}>
									<span>{index + 1}</span>
									{module}
								</li>
							))}
						</ol>
					</ModuleList>
					<FeatureList>
						<Feature>
							<Icon>
								<AssignmentOutlinedIcon />
							</Icon>
							{t('general.trainingOptions.online.finalExam')}
						</Feature>
						<Feature>
							<Icon>
								<AccessTimeOutlinedIcon />
							</Icon>
							{t('general.trainingOptions.online.hours')}
						</Feature>
						<Feature>
							<Icon>
								<EmojiEventsOutlinedIcon />
							</Icon>
							{t('general.trainingOptions.online.certificate')}
						</Feature>
					</FeatureList>
					<Callout className="online-callout">
						<PlayCircleOutlineIcon />
						{t('general.trainingOptions.online.callout')}
					</Callout>
				</OptionCard>

				<OptionCard
					as="a"
					className="option-card-link"
					href="https://fetalmedicinebarcelona.org/interactivo3/"
					target="_blank"
					rel="noopener noreferrer"
					aria-label={t('general.trainingOptions.hybrid.title')}
				>
					<OptionHeading>
						<Icon>
							<CastForEducationIcon />
						</Icon>
						<Typography variant="h3">
							<span>{t('general.trainingOptions.hybrid.titleFirst')}</span>{' '}
							<span className="title-second">
								{t('general.trainingOptions.hybrid.titleSecond')}
							</span>
						</Typography>
					</OptionHeading>
					<OptionDivider />
					<Feature className="included-online">
						<Icon>
							<DesktopMacOutlinedIcon />
						</Icon>
						{t('general.trainingOptions.hybrid.includesOnline')}
					</Feature>
					<PlusDivider>
						<span />
						<AddIcon />
						<span />
					</PlusDivider>
					<HybridFeatureList>
						<Feature>
							<Icon>
								<SchoolOutlinedIcon />
							</Icon>
							{t('general.trainingOptions.hybrid.training')}
						</Feature>
						<Feature>
							<Icon>
								<AccessTimeOutlinedIcon />
							</Icon>
							{t('general.trainingOptions.hybrid.hours')}
						</Feature>
						<Feature>
							<Icon>
								<DesktopMacOutlinedIcon />
							</Icon>
							{t('general.trainingOptions.hybrid.library')}
						</Feature>
						<Feature>
							<Icon>
								<AssignmentOutlinedIcon />
							</Icon>
							{t('general.trainingOptions.hybrid.finalExam')}
						</Feature>
						<Feature>
							<Icon>
								<EmojiEventsOutlinedIcon />
							</Icon>
							{t('general.trainingOptions.hybrid.certificate')}
						</Feature>
					</HybridFeatureList>
					<Callout className="hybrid-callout">
						<DesktopMacOutlinedIcon />
						{t('general.trainingOptions.hybrid.callout')}
					</Callout>
				</OptionCard>
			</OptionsGrid>
		</TrainingOptionsContainer>
	);
};

export default TrainingOptions;
